export const EXHIBITION_PATHS = ['/buyer-outlook-exhibition']
export const NOTICE_PATHS = ['/notice/news', '/notice/utilize', '/limite-time-event']
export const NO_ACCOUNT_FEATURE_PATHS = ['/onboarding/*']
